document.addEventListener('turbolinks:load', function () {
  //- ハッシュタグ検索の初期の画面でフィルターをかける処理
  let current_url = window.location.href;

  common_media_count_up = -1;
  let fileObject = {}; // [{0: File}, {1: File}] のような形で初期の順番を保持する
  let mpm_files = []; // 追加された画像のデータを保存する
  const MPM_MAX_SIZE_MB = 100; // 手動自社投稿で追加できるファイルのサイズ(サーバーに保存するもののみ)

  const conduct_sortable = function (new_or_edit, sns_post_id_for_update = null) {
    // ¥ edit時に毎回新しく追加される要素の数を追跡するために作成
    let duplicate_mpm_files = [];
    let fileIndex = 0; // New variable for tracking the file index.

    let inputFile;
    let my_post_media_drop_input;
    let mpm_preview_own_media_area;
    let previewArea;
    let mpm_delete_preview_icon;
    let sortable_id;
    let delete_existing_media_orders_flag;
    let mpm_instagram_url_obj;
    let all_db_permalink_list; // ¥ 新規作成のみ使用

    // ¥ 新規登録ボタンを押した時の変数
    if (new_or_edit === 'new') {
      // ¥ 文字列から配列に変更している
      all_db_permalink_list = JSON.parse($('#all_db_permalink_list').attr('data-permalink_list'));
      open_modal_container_btn = $('#new_product_set_btn');
      platta_ig_modal_container = $('.platta_ig_modal_container');
      inputFile = $('#my_post_media_reinput');
      my_post_media_drop_input = $('.my_post_media_drop_input');
      mpm_preview_own_media_area = $('.mpm_preview_own_media_area');
      previewArea = $('.preview_shown_media_area').first(); // 複数あるうちの一番始めの DOM elementを取得する
      submit_btn = $('#my_post_manual_post_submit_btn');
      sortable_id = -1;
      delete_existing_media_orders_flag = 0; // 0の場合、rails側で既存のデータを削除しない
      mpm_instagram_url_obj = $('#mpm_instagram_url');
      mpm_username_obj = $('#mpm_username');
      // ¥ 編集ボタンを押した時の変数
    } else if (new_or_edit === 'edit') {
      all_db_permalink_list = JSON.parse($('#all_db_permalink_list').attr('data-permalink_list'));
      open_modal_container_btn = $('.mpm_item_list__edit');
      platta_ig_modal_container = $('.mpm_platta_ig_edit_modal_container');
      inputFile = $('#my_post_media_edit_reinput');
      my_post_media_drop_input = $('.my_post_media_edit_drop_input');
      mpm_preview_own_media_area = $('.mpm_preview_own_edit_media_area');
      previewArea = $('.preview_shown_media_area_for_edit').first(); // 複数あるうちの一番始めの DOM elementを取得する
      submit_btn = $('#my_post_manual_update_post_submit_btn');
      sortable_id = -1;
      delete_existing_media_orders_flag = 0; // 0の場合、rails側で既存のデータを削除しない
      mpm_instagram_url_obj = $('#mpm_edit_instagram_url');
      mpm_username_obj = $('#mpm_edit_username');
    }

    // ¥ previewAreaに入っているメディアを削除し初期化する
    previewArea.empty();

    const validVideoTypes = ['video/mp4', 'video/webm', 'video/ogg'];

    // ¥ mousedownイベントを使うことで、ファイルダイアログを重複して発生させないようにしている
    my_post_media_drop_input.on('mousedown', function (event) {
      event.preventDefault();
      inputFile.off('click').click();
    });

    inputFile.off('click').on('click', function (event) {
      event.stopPropagation();
    });

    // ¥ 画像。動画アップロードでクリックしてファイルを選択するときの処理
    inputFile.on('change', function () {
      let clicked_inserted_files = $(this).prop('files');

      for (let index = 0; index < clicked_inserted_files.length; index++) {
        const file = clicked_inserted_files[index];
        if (file.size > MPM_MAX_SIZE_MB * 1024 * 1024) {
          alert(`◆ファイル名: ${file.name} が許容ファイルサイズの${MPM_MAX_SIZE_MB}MBを超えています。それ以下のサイズのファイルを選択してください。`);
          return;
        }
      }

      let dup_common_media_count_up = common_media_count_up;

      if (new_or_edit === 'edit') {
        for (let i = 0; i < clicked_inserted_files.length; i++) {
          dup_common_media_count_up++;
          fileObject = {};
          fileObject[dup_common_media_count_up] = clicked_inserted_files[i];
          mpm_files.push(fileObject);
        }
      } else if (new_or_edit === 'new') {
        for (let i = 0; i < clicked_inserted_files.length; i++) {
          dup_common_media_count_up++;
          fileObject = {};
          fileObject[dup_common_media_count_up] = clicked_inserted_files[i];
          mpm_files.push(fileObject);
        }
      }

      processFiles(Array.from(clicked_inserted_files));
    });

    mpm_preview_own_media_area.on('dragover', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.originalEvent.dataTransfer.dropEffect = 'copy';

      mpm_preview_own_media_area.addClass('back_ground_color_antiquewhite');
    });

    mpm_preview_own_media_area.on('dragleave', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.originalEvent.dataTransfer.dropEffect = 'copy';

      mpm_preview_own_media_area.removeClass('back_ground_color_antiquewhite');
    });

    mpm_preview_own_media_area.on('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();

      let dup_common_media_count_up = common_media_count_up;

      let files = Array.from(e.originalEvent.dataTransfer.files);

      for (let i = 0; i < files.length; i++) {
        let file = files[i];

        console.log('file.size---', file.size);

        // file.size > 20 * 1024 * 1024) 20の部分が20MBとなる
        if (file.size > MPM_MAX_SIZE_MB * 1024 * 1024) {
          alert(`ファイル名: ${file.name} が許容ファイルサイズの${MPM_MAX_SIZE_MB}MBを超えています。それ以下のサイズのファイルを選択してください。`);
          return;
        } else {
          dup_common_media_count_up++;
          fileObject = {};
          fileObject[dup_common_media_count_up] = file;
          mpm_files.push(fileObject);
        }
      }

      processFiles(Array.from(e.originalEvent.dataTransfer.files));
      mpm_preview_own_media_area.removeClass('back_ground_color_antiquewhite');
    });

    // let previewArea = document.querySelector(".preview_shown_media_area");
    // ! new Sortable(previewArea[0] の第一引数は HTML elementである必要がある(そうでないとエラーが起きる)ため、
    //! jqueryオブジェクトであるpreviewAreaを previewArea[0]とすることで、HTML elementに直している。
    let sortableInstance = new Sortable(previewArea[0], {
      animation: 150,
      handle: '.mpm_media_wrapper',
    });

    // ¥ event delegation
    // new用と edit用の二種類が必要! 要修正
    previewArea.on(
      'click',
      '.mpm_delete_preview_icon',

      // ¥ dom上から削除した要素に対応する要素を配列から削除する
      function (e) {
        let parentElement = $(this).parent();
        let parentIndex = parentElement.index(); // get the index of the parent element in the DOM

        let existing_media_html_elements = $('.preview_shown_media_area_for_edit').children();

        let parentElementDataId = $(parentElement).data('id');
        parentElement.remove(); // remove the element from the DOM

        mpm_files = mpm_files.filter(function (item) {
          return Object.keys(item)[0] !== String(parentElementDataId);
        });
        // ¥ 20230818 プレビュー画面の画像が削除されたことを記録するflag
      }
    );

    function processFiles(files) {
      if (fileIndex < files.length) {
        // ¥ .then()はresolveしてから次の処理にう移るという意味 このようにすることでファイルが選択された順番を担保している
        processFile(files[fileIndex]).then(() => {
          fileIndex++;
          processFiles(files);
        });
      } else {
        fileIndex = 0;
      }
    }

    // ! 非同期 reader.readAsDataURL(file); のため、ファイルを追加した順で取得することができない
    // ! それを回避するためfunction processFiles(files) や resolveを使い、
    // ! ファイルを追加した順で表示させられるようにした 20230611
    function processFile(file) {
      return new Promise((resolve, reject) => {
        if (!file.type.match(/image.*|video.*/)) {
          // ¥ ファイルタイプが合わなければそこで処理を終了している
          resolve();
        }

        let reader = new FileReader();
        reader.onload = function (e) {
          let dataUrlScheme = reader.result;
          let fileName = encodeURIComponent(file.name);
          let src = e.target.result;

          if (file.type.match(/image.*/)) {
            appendMediaWithCheck('img', src, fileName, dataUrlScheme);
          } else if (validVideoTypes.includes(file.type)) {
            appendMediaWithCheck('video', src, fileName, dataUrlScheme);
          } else {
            return;
          }
          resolve();
        };
        reader.readAsDataURL(file);
      });
    }

    let hasAlerted = false;
    let hasAlertedCount = 0;

    // alertが複数回発生しないようにするために作成
    function appendMediaWithCheck(tagName, src, fileName, dataUrlScheme) {
      if ($('.mpm_media_wrapper').length < 10) {
        hasAlerted = false;
        hasAlertedCount = 0;
      } else if ($('.mpm_media_wrapper').length >= 10) {
        hasAlerted = true;
      }

      if (hasAlerted) {
        if (hasAlertedCount < 1) {
          alert('--紐付けることのできるファイルの上限10個を超えています。10個以内でファイルを選択してください--');
        }
        hasAlertedCount++;
        return;
      }

      appendMedia(tagName, src, fileName, dataUrlScheme);
    }

    function appendMedia(tagName, src, fileName, dataUrlScheme) {
      common_media_count_up++;
      let media;

      let closeTag = tagName == 'video' ? `</${tagName}>` : '';
      media = `<div class="mpm_media_wrapper relative cursor-move inline-block" data-id=${common_media_count_up}>
                <${tagName} class="mpm_preview_own_media pointer-events-none w-100px h-100px mr-1" data-id=${common_media_count_up} controls src="${src}">${closeTag}
                <div class="mpm_delete_preview_icon absolute z-10 top-[-10px] right-[-2px] w-5 h-5 cursor-pointer text-center" data-id=${common_media_count_up}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>`;

      previewArea.append(media);
    }

    submit_btn.off('click').on('click', function () {
      let mpm_instagram_url = mpm_instagram_url_obj.val().trim();
      if (mpm_instagram_url.endsWith('/')) {
        mpm_instagram_url = mpm_instagram_url.slice(0, -1);
      }

      let mpm_username = mpm_username_obj.val().trim();

      let mpm_caption;
      if (new_or_edit == 'new') {
        mpm_caption = $('#mpm_caption').val();
      } else if (new_or_edit == 'edit') {
        mpm_caption = $('#mpm_edit_caption').val();
      }

      // ¥ インスタurlが重複している時のalert
      if (mpm_instagram_url_obj.val()) {
        // ! && new_or_edit == 'new')  を削除した 20230817
        if (all_db_permalink_list && all_db_permalink_list.includes(mpm_instagram_url_obj.val()) && new_or_edit == 'new') {
          // if (all_db_permalink_list && all_db_permalink_list.includes(mpm_instagram_url_obj.val())) {
          let yes_or_no = confirm('すでにこのインスタグラムのurlに紐づく投稿は登録されています。\n既存の情報を全て削除し、今回の内容を新しく登録してもよろしいですか?');
          if (yes_or_no == false) {
            submit_btn.css('pointer-events', 'auto');
            return;
          } else {
            delete_existing_media_orders_flag = 1;
          }
        }
      }

      if (mpm_files.length === 0 && $('.preview_shown_media_area_for_edit').length === 0 && $('.mpm_media_wrapper').length === 0) {
        alert('画像か動画を少なくとも1つアップロードしてください。');
        submit_btn.css('pointer-events', 'auto');
        return;
      } else {
        // Add the code you want to execute when neither of the above conditions is met.
      }

      let formData = new FormData();
      formData.append('mpm_instagram_url', mpm_instagram_url);
      formData.append('mpm_caption', mpm_caption);
      formData.append('mpm_username', mpm_username);

      let newOrder = sortableInstance.toArray();

      let reorderedFiles;

      // Reorder the original list
      let new_reordered_list = newOrder.map((o) =>
        mpm_files.find((item) => {
          return String(Object.keys(item)[0]) === o;
        })
      );

      // ¥ Update the keys to be ascending from 1 inside each object
      let modified_reordered_list = new_reordered_list.map((obj, index) => {
        let key = Object.keys(obj)[0];
        let newObj = {};
        newObj[index + 1] = obj[key];
        return newObj;
      });

      ////////////////  保存 or 更新するメディアの追加方法別に配列を用意する ///////////////////////
      let reorderedFileArray = []; // FormData object (画像・動画アップロード)
      let reorderedMediaUrlArray = []; // Media url (メディアURL)
      let reorderedExistingDataArray = []; // DBに保存されているデータの更新 (DBのデータ)

      let FormDataOrderList = [];
      let MediaUrlOrderList = [];
      let DbExistingDataList = [];

      for (let i = 0; i < modified_reordered_list.length; i++) {
        let element = modified_reordered_list[i];

        for (let key in element) {
          let value = element[key];

          if (value instanceof File) {
            reorderedFileArray.push(value);
            FormDataOrderList.push(Number(key));
          } else if (typeof value === 'string' && (value.includes('https://') || value.includes('http://'))) {
            reorderedMediaUrlArray.push(value);
            MediaUrlOrderList.push(Number(key));
          } else if (typeof value === 'number') {
            reorderedExistingDataArray.push(value);
            DbExistingDataList.push(Number(key));
          }
        }
      }
      ////////////////  保存 or 更新するメディアの追加方法別に配列を用意する END ///////////////////////

      // ¥ 並び替えが終わった後のファイル順で ループする 20230614
      /////////////////////  FormDataOrderList ///////////////////////////
      reorderedFileArray.forEach(function (file, file_index) {
        // console.log("original-file:", file.name);
        formData.append('mpm_file_type_list[]', file.type);
        formData.append('mpm_file_last_modified_list[]', file.lastModified); // Add this line
        // formData.append("mpm_file_order_list[]", newOrder[file_index]); // 画像の元々の並び順
        formData.append('mpm_media_list[]', file);
        formData.set('mpm_delete_existing_media_orders_flag', delete_existing_media_orders_flag);
        // ¥ この順番がDBに保存される画像の順番となる
        formData.append('mpm_form_data_order_list[]', FormDataOrderList[file_index]);
      });

      /////////////////////  MediaUrlOrderList ///////////////////////////

      // ¥ 並び替えが終わった後のファイル順で ループする jsonで対応する
      let mpm_reordered_media_url_list = [];
      let mpm_file_type_list = [];
      let mpm_media_url_order_list = [];

      // MediaUrlOrderList!!!!!!! (4) [1, 4, 7, 8]
      if (reorderedMediaUrlArray.length > 0) {
        // ¥ 並び替えが終わった後のファイル順で ループする jsonで対応する
        reorderedMediaUrlArray.forEach(function (file, file_index) {
          let mpm_reordered_media_url = reorderedMediaUrlArray[file_index];
          mpm_reordered_media_url_list.push(mpm_reordered_media_url);

          let fileExtension = file.split('.').pop().toLowerCase();

          if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
            // aaa
            mpm_file_type_list.push('VIDEO');
          } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
            // bbb
            mpm_file_type_list.push('IMAGE');
          }

          mpm_media_url_order_list.push(MediaUrlOrderList[file_index]);
        });
      }

      /////////////////////  DbExistingDataList ///////////////////////////
      // ¥ 並び替えが終わった後のファイル順で ループする jsonで対応する
      let mpm_reordered_existing_data_list = [];
      let mpm_existing_data_order_list = [];

      // DbExistingDataList!!!!!!! (4) [1, 4, 7, 8]
      if (reorderedExistingDataArray.length > 0) {
        // ¥ 並び替えが終わった後のファイル順で ループする jsonで対応する
        reorderedExistingDataArray.forEach(function (file, file_index) {
          let mpm_db_id = reorderedExistingDataArray[file_index];
          mpm_reordered_existing_data_list.push(mpm_db_id);
          mpm_existing_data_order_list.push(DbExistingDataList[file_index]);
        });
      }

      // ¥ 20230616 ajaxを関数にし、return $.ajax()とすることで Promiseを返し、そこから .then()でつなげることで ajaxの走る順番をコントロールできるようにしている
      // ! Make the ajax function return the Promise from $.ajax
      //  ¥ 20230817
      // const ajax_save_manual_my_post = function (alarm_flag = true, sns_post_id_for_update = '') {
      const ajax_save_manual_my_post = function (alarm_flag = true, sns_post_id_for_update = '', delete_existing_media_orders_flag = 0) {
        if (sns_post_id_for_update === null) {
          sns_post_id_for_update = '';
        }
        formData.append('sns_post_id_for_update', sns_post_id_for_update);
        // ! 20230818 editの処理で全ての画像を削除してから画像を追加したときの動作時に既存のデータを削除し、新しいデータのみを追加するために下記を追加
        formData.set('mpm_delete_existing_media_orders_flag', delete_existing_media_orders_flag);

        return $.ajax({
          url: '/save_manual_my_post',
          type: 'POST',
          data: formData,
          contentType: false,
          processData: false,
        })
          .done(function (data) {
            if ((new_or_edit = 'new')) {
              if (alarm_flag) {
                alert(`投稿情報を登録しました。`);
                location.reload();
              }
            }
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            console.log(`errorThrown... ${errorThrown}`);
            console.log(`jqXHR... ${jqXHR}`);
            // Check if the server sent a custom error message
            let customMessage = jqXHR.responseJSON && jqXHR.responseJSON.message;
            console.log('customMessage:::', customMessage);
            let err_msg = '予期せぬエラーが発生しました。ファイル名に特殊文字(絵文字や【】等)が含まれている場合は削除し、ファイル名が長い場合は、短くしてから再度お試しください。';
            alert(err_msg);
            location.reload();
          });
      };

      const ajax_save_manual_my_post_media_url = function (
        // ¥ 20230817
        sns_post_id_for_update = '',
        mpm_file_type_list,
        mpm_reordered_media_url_list,
        mpm_media_url_order_list,
        // ¥ 上書き用
        delete_existing_media_orders_flag,
        alarm_flag = true,
        // ¥ .then() で取得する 前の処理で新たに作成されたレコードをハッシュ形式で保持 {1078=>1}
        // ¥ editの際に直前の関数で新たに作成されたレコードを引き継ぐために使用する
        created_records_hash = ''
      ) {
        return $.ajax({
          url: '/save_manual_my_post_media_url',
          type: 'POST',
          data: {
            // ¥ 20230817
            sns_post_id_for_update: sns_post_id_for_update,
            mpm_instagram_url: mpm_instagram_url,
            mpm_caption: mpm_caption,
            mpm_delete_existing_media_orders_flag: delete_existing_media_orders_flag,
            mpm_file_type_list: mpm_file_type_list,
            // urlを保持
            mpm_reordered_media_url_list: mpm_reordered_media_url_list,
            // メディアの並び順を保持
            mpm_media_url_order_list: mpm_media_url_order_list,
            created_records_hash: created_records_hash,
          },
          dataType: 'json',
        })
          .done(function (data) {
            if (alarm_flag) {
              alert(`投稿情報を登録しました。`);
              location.reload();
            }
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            console.log(`errorThrown... ${errorThrown}`);
            console.log(`jqXHR... ${jqXHR}`);
            // Check if the server sent a custom error message
            let customMessage = jqXHR.responseJSON && jqXHR.responseJSON.message;
            console.log('customMessage:::', customMessage);
            let err_msg = '予期せぬエラーが発生しました。ファイル名に特殊文字(絵文字や【】等)が含まれている場合は削除し、ファイル名が長い場合は、短くしてから再度お試しください。';
            alert(err_msg);
            location.reload();
          });
      };

      // ¥ 更新用
      const ajax_update_manual_my_post = function (
        sns_post_id_for_update,
        mpm_instagram_url,
        mpm_caption,
        mpm_existing_data_order_list,
        mpm_reordered_existing_data_list,
        // ¥ 上書き用
        delete_existing_media_orders_flag,
        alarm_flag = true,
        //  20230818
        // sns_post_id_and_created_records_hash_list
        created_records_hash
      ) {
        if (!sns_post_id_for_update) {
          sns_post_id_for_update = sns_post_id_and_created_records_hash_list['sns_post_id'];
        }
        return $.ajax({
          url: '/update_manual_my_post',
          type: 'POST',
          data: {
            mpm_sns_post_id: sns_post_id_for_update,
            mpm_instagram_url: mpm_instagram_url,
            mpm_username: mpm_username,
            mpm_caption: mpm_caption,
            mpm_delete_existing_media_orders_flag: delete_existing_media_orders_flag,
            // my_post_media_orders の各レコードのid を配列で保持
            mpm_reordered_existing_data_list: mpm_reordered_existing_data_list,
            // メディアの並び順を保持
            mpm_existing_data_order_list: mpm_existing_data_order_list,
            created_records_hash,
          },
          dataType: 'json',
        })
          .done(function (data) {
            if (alarm_flag) {
              alert(`投稿情報を登録しました。`);
              location.reload();
            }
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            console.log(`errorThrown... ${errorThrown}`);
            console.log(`jqXHR... ${jqXHR}`);
            // Check if the server sent a custom error message
            let customMessage = jqXHR.responseJSON && jqXHR.responseJSON.message;
            console.log('customMessage:::', customMessage);
            let err_msg = '予期せぬエラーが発生しました。ファイル名に特殊文字(絵文字や【】等)が含まれている場合は削除し、ファイル名が長い場合は、短くしてから再度お試しください。';
            alert(err_msg);
            location.reload();
          });
      };

      // ¥ 1 下記のように .then で繋げて、前の非同期処理が完全に終了してから次の非同期処理に進ませる 20230616
      if (new_or_edit === 'new') {
        if (reorderedFileArray.length == 0 && reorderedMediaUrlArray.length == 0) {
          alert('画像、動画を1枚以上選択してください。');
          submit_btn.css('pointer-events', 'auto'); // 20230817
        }
        // ¥ 新規登録の場合の処理
        if (reorderedFileArray.length > 0 && reorderedMediaUrlArray.length > 0) {
          // console.log('ajax 1  ajax_save_manual_my_post().then(ajax_save_manual_my_post_media_url);');
          ajax_save_manual_my_post((alarm_flag = false), sns_post_id_for_update).then(function (sns_post_id_and_created_records_hash_list = {}) {
            if (!sns_post_id_for_update) {
              sns_post_id_for_update = sns_post_id_and_created_records_hash_list['sns_post_id'];
            }
            ajax_save_manual_my_post_media_url(
              sns_post_id_for_update,
              mpm_file_type_list,
              mpm_reordered_media_url_list,
              mpm_media_url_order_list,
              // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
              (delete_existing_media_orders_flag = 0),
              (alarm_flag = true),
              (created_records_hash = sns_post_id_and_created_records_hash_list['created_records'])
            );
          });
        } else if (reorderedFileArray.length > 0 && reorderedMediaUrlArray.length == 0) {
          // console.log('ajax 2   ajax_save_manual_my_post();');
          ajax_save_manual_my_post((alarm_flag = true), sns_post_id_for_update);
        }
        // ¥ 3
        else if (reorderedFileArray.length == 0 && reorderedMediaUrlArray.length > 0) {
          // console.log('ajax 3   ajax_save_manual_my_post_media_url();');
          ajax_save_manual_my_post_media_url(
            sns_post_id_for_update,
            mpm_file_type_list,
            mpm_reordered_media_url_list,
            mpm_media_url_order_list,
            // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
            delete_existing_media_orders_flag,
            (alarm_flag = true),
            // ¥ .then() で取得する 前の処理で新たに作成されたレコードをハッシュ形式で保持 {1078=>1}
            // ¥ editの際に直前の関数で新たに作成されたレコードを引き継ぐために使用する
            (created_records_hash = '')
          );
        }

        //^ /////////////////////// 画像の並び順や差し替え等の変更を行う場合 //////////////////////
      } else if (new_or_edit === 'edit') {
        // ¥検証 20230617
        if (reorderedFileArray.length === 0 && reorderedMediaUrlArray.length === 0 && reorderedExistingDataArray.length === 0) {
          alert('メディアを1枚以上選択してください。');
          return;
        } else if (reorderedFileArray.length > 0 && (reorderedMediaUrlArray.length > 0) & (reorderedExistingDataArray.length > 0)) {
          // console.log('edit 01 ajax 1  ajax_save_manual_my_post().then(ajax_save_manual_my_post_media_url);');
          // ¥ sns_post_id_and_created_records_hash_list は コントローラーの def save_manual_my_post の return
          ajax_save_manual_my_post((alarm_flag = false), sns_post_id_for_update).then(function (sns_post_id_and_created_records_hash_list = {}) {
            ajax_save_manual_my_post_media_url(
              // ¥ 20230817
              (sns_post_id_for_update = sns_post_id_and_created_records_hash_list['sns_post_id']),
              mpm_file_type_list,
              mpm_reordered_media_url_list,
              mpm_media_url_order_list,
              // ¥ DBの更新及び削除はajax_update_manual_my_postでするため 0
              (delete_existing_media_orders_flag = 0),
              (alarm_flag = false),
              // (alarm_flag = true),
              // created_records_hash
              (created_records_hash = sns_post_id_and_created_records_hash_list['created_records'])
              // ).then(function (created_records_hash = '', sns_post_id_for_update = '') {
            ).then(function (sns_post_id_and_created_records_hash_list = {}) {
              ajax_update_manual_my_post(
                (sns_post_id_for_update = sns_post_id_and_created_records_hash_list['sns_post_id']),
                mpm_instagram_url,
                mpm_caption,
                mpm_existing_data_order_list,
                mpm_reordered_existing_data_list,
                // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
                (delete_existing_media_orders_flag = 1),
                (alarm_flag = true),
                (created_records_hash = sns_post_id_and_created_records_hash_list['created_records'])
              );
            });
          });
        } else if (reorderedFileArray.length == 0 && (reorderedMediaUrlArray.length > 0) & (reorderedExistingDataArray.length > 0)) {
          // console.log('edit ajax 2  ajax_save_manual_my_post().then(ajax_save_manual_my_post_media_url);');
          ajax_save_manual_my_post_media_url(
            // 20230817
            sns_post_id_for_update,
            mpm_file_type_list,
            mpm_reordered_media_url_list,
            mpm_media_url_order_list,
            // ¥ DBの更新及び削除はajax_update_manual_my_postでするため 0
            (delete_existing_media_orders_flag = 0),
            // (alarm_flag = false)
            (alarm_flag = false)
            //¥ def save_manual_my_post_media_url の結果(render json: sns_post_id_and_created_records_hash_list)を取得する 20230817
          ).then(function (sns_post_id_and_created_records_hash_list) {
            if (!sns_post_id_for_update) {
              sns_post_id_for_update = sns_post_id_and_created_records_hash_list['sns_post_id'];
            }
            ajax_update_manual_my_post(
              sns_post_id_for_update,
              mpm_instagram_url,
              mpm_caption,
              mpm_existing_data_order_list,
              mpm_reordered_existing_data_list,
              // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
              (delete_existing_media_orders_flag = 1),
              (alarm_flag = true),
              (created_records_hash = sns_post_id_and_created_records_hash_list['created_records'])
            );
          });
        } else if (reorderedFileArray.length > 0 && (reorderedMediaUrlArray.length === 0) & (reorderedExistingDataArray.length > 0)) {
          // console.log('ajax 3  ajax_save_manual_my_post().then(ajax_save_manual_my_post_media_url);');

          // - 20230817 引数に sns_post_id_for_update を追加
          ajax_save_manual_my_post((alarm_flag = false), (sns_post_id_for_update = sns_post_id_for_update)).then(function (sns_post_id_and_created_records_hash_list = {}) {
            ajax_update_manual_my_post(
              (sns_post_id_for_update = sns_post_id_and_created_records_hash_list['sns_post_id']),
              mpm_instagram_url,
              mpm_caption,
              mpm_existing_data_order_list,
              mpm_reordered_existing_data_list,
              // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
              (delete_existing_media_orders_flag = 1),
              (alarm_flag = true),
              (created_records_hash = sns_post_id_and_created_records_hash_list['created_records'])
            );
          });
        } else if (reorderedFileArray.length === 0 && (reorderedMediaUrlArray.length === 0) & (reorderedExistingDataArray.length > 0)) {
          // console.log('ajax 4  ajax_save_manual_my_post().then(ajax_save_manual_my_post_media_url);');
          ajax_update_manual_my_post(
            sns_post_id_for_update,
            mpm_instagram_url,
            mpm_caption,
            mpm_existing_data_order_list,
            mpm_reordered_existing_data_list,
            // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
            (delete_existing_media_orders_flag = 1),
            (alarm_flag = true),
            (created_records_hash = '')
          );
        }
        // ¥ 20230818 編集画面でプレビューの画像を全て削除してから画像を追加している処理の場合の場合分け
        else if (reorderedFileArray.length > 0 && reorderedMediaUrlArray.length > 0) {
          // console.log('ajax 6  ajax_save_manual_my_post().then(ajax_save_manual_my_post_media_url);');
          // ! 20230818 delete_existing_media_orders_flag = 1を 追加 プレビュー画像を全て消してから追加の処理をしているため一度、既存のデータを削除し、その上に新しいデータを追加するため
          ajax_save_manual_my_post((alarm_flag = false), sns_post_id_for_update, (delete_existing_media_orders_flag = 1)).then(function (sns_post_id_and_created_records_hash_list = {}) {
            ajax_save_manual_my_post_media_url(
              sns_post_id_for_update,
              mpm_file_type_list,
              mpm_reordered_media_url_list,
              mpm_media_url_order_list,
              // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
              (delete_existing_media_orders_flag = 0),
              (alarm_flag = true),
              // created_records_hash
              (created_records_hash = sns_post_id_and_created_records_hash_list['created_records'])
            );
          });
        } else if (reorderedFileArray.length > 0 && reorderedMediaUrlArray.length == 0) {
          // console.log('ajax 7   ajax_save_manual_my_post();');
          ajax_save_manual_my_post((alarm_flag = true), sns_post_id_for_update, (delete_existing_media_orders_flag = 1));
        }
        // ¥ 3
        else if (reorderedFileArray.length == 0 && reorderedMediaUrlArray.length > 0) {
          // console.log('ajax 8   ajax_save_manual_my_post_media_url();');
          ajax_save_manual_my_post_media_url(
            sns_post_id_for_update,
            mpm_file_type_list,
            mpm_reordered_media_url_list,
            mpm_media_url_order_list,
            // ¥ DBの初期化はajax_save_manual_my_post()で行われるため2回目ではしない設定に上書きする
            (delete_existing_media_orders_flag = 1),
            (alarm_flag = true),
            // ¥ .then() で取得する 前の処理で新たに作成されたレコードをハッシュ形式で保持 {1078=>1}
            // ¥ editの際に直前の関数で新たに作成されたレコードを引き継ぐために使用する
            (created_records_hash = '')
          );
        }
      }
    });
    return previewArea;
  };

  let mpm_url_list = [];

  // プレビューエリアにメディアを表示させる処理
  const insert_media_to_preview_area = function (preview_area, mpm_media_url_list, media_url_count_up) {
    for (let mmu_idx = 0; mmu_idx < mpm_media_url_list.length; mmu_idx++) {
      let media_url = mpm_media_url_list[mmu_idx];

      dup_common_media_count_up = common_media_count_up;

      dup_common_media_count_up++;
      // ¥ 並び替えされる前の挿入された順を保持するために作成
      fileObject = {};
      fileObject[dup_common_media_count_up] = media_url;
      mpm_files.push(fileObject);

      media_url_count_up++;

      if ($('.mpm_media_wrapper') && $('.mpm_media_wrapper').length >= 10) {
        alert('▼紐付けることのできるファイルの上限10個を超えています。10個以内でファイルを追加してください');
        // ¥ すでに配列に含まれてしまった超過分の要素を削除する
        mpm_files.pop();
        break;
      }

      // Obtain the file extension
      let fileExtension = media_url.split('.').pop().toLowerCase();

      common_media_count_up++;

      // Define media tags based on file type
      let media;
      if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
        // add more video extensions if needed
        media = `<div class="mpm_media_wrapper relative cursor-move inline-block" data-id='${common_media_count_up}'>
                  <video class="mpm_preview_own_media pointer-events-none w-100px h-100px mr-1" data-id='${common_media_count_up}' controls>
                    <source src="${media_url}" type="video/${fileExtension}">
                    Your browser does not support the video tag.
                  </video>
                  <div class="mpm_delete_preview_icon absolute z-10 top-[-10px] right-[-2px] w-5 h-5 cursor-pointer text-center" data-id='${common_media_count_up}'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>`;
      } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
        // add more image extensions if needed
        media = `<div class="mpm_media_wrapper relative cursor-move inline-block" data-id='${common_media_count_up}'>
                  <img class="mpm_preview_own_media pointer-events-none w-100px h-100px mr-1" data-id='${common_media_count_up}' src="${media_url}" />
                  <div class="mpm_delete_preview_icon absolute z-10 top-[-10px] right-[-2px] w-5 h-5 cursor-pointer text-center" data-id='${common_media_count_up}'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>`;
      }
      preview_area.first().append(media);
    } // for文 end
  };

  // ¥ モーダル処理

  $('#new_mpm_post_set_btn')
    .off('click')
    .on('click', function () {
      conduct_sortable('new'); //¥ 新規登録時の処理
      // $('.mpm_platta_ig_modal_container').fadeIn(100);

      let media_url_count_up = -1;

      // ¥ 画像urlをプレビューエリアに表示させる処理
      $('.mpm_media_url__add_btn')
        .first()
        .off('click')
        .on('click', function () {
          let mpm_media_url_list = get_url_list('#mpm_media_url');

          if (mpm_media_url_list === null) return;

          $('#mpm_media_url').val('');

          const $preview_shown_media_area = $('.preview_shown_media_area');
          insert_media_to_preview_area($preview_shown_media_area, mpm_media_url_list, media_url_count_up);
        });
    });

  // ^ 新規登録 及び 編集モーダルを閉じる
  $('.mpm_platta_ig_modal_del')
    .off('click')
    .on('click', function () {
      $('.mpm_platta_ig_modal_container, .mpm_platta_ig_edit_modal_container').fadeOut(0);
      location.reload();
    });
  $('.mpm_platta_ig_edit_modal_del')
    .off('click')
    .on('click', function () {
      $('.mpm_platta_ig_edit_modal_container').fadeOut(0);
      location.reload();
    });
  $('.mpm_platta_ig_modal_bg')
    .off('click')
    .on('click', function () {
      $('.mpm_platta_ig_modal_container').fadeOut(0);
      $('.mpm_platta_ig_edit_modal_container').fadeOut(0);
      location.reload();
    });

  // !!!!!!!!!!!!!!!!!!!!!! サーチ !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  $('#mpm_search__search').on('keypress', function (e) {
    if (e.which === 13) {
      e.preventDefault(); // デフォルトのエンターキーの挙動を無効にする
      let search_word = $(this).val();
      if (search_word.endsWith('/')) {
        search_word = search_word.slice(0, -1);
      }
      location.href = `/manual_add_sns_post?mpm_item=${search_word}`;
    }
  });

  // !!!!!!!!!!!!!!!!!!!!!! サーチ リセット !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  $('.all_mpm_item_list')
    .off('click')
    .on('click', function () {
      location.href = `/manual_add_sns_post`;
    });

  // ¥ sns_postsを更新する際に使用する 20230617
  // !!!!!!!!!!!!!!!!!!!!!! 編集モーダル!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  $('.mpm_item_list__edit')
    .off('click')
    .on('click', function () {
      let mpm_item_instagram_url = $(this).data('instagram_url');
      let mpm_username = $(this).data('username');
      // let mpm_item_price = $(this).data("price");
      let mpm_item_caption = $(this).data('caption');
      let mpm_sns_post_id = String($(this).data('id'));

      let mpm_item_list = $('.mpm_item_list__product_media')
        .map(function () {
          let src = $(this).attr('src');
          let dataSnsPostId = $(this).attr('data-sns_post_id');
          let data_mpm = $(this).attr('data-mpm_id');
          if (dataSnsPostId === mpm_sns_post_id) {
            return { mpm_id: data_mpm, src: src };
          }
        })
        .get();

      // !!!!!!!!!!! sortable の処理 !!!!!!!!!!!!!!!!!!!!!!!!!!!
      let previewArea = conduct_sortable('edit', mpm_sns_post_id); // ¥ 編集ボタンが押された時
      // !!!!!!!!!!! 編集画面上のsortable の処理 END !!!!!!!!!!!!!!!!!!!!!!!!!!!

      // !!!!!!! data-idで一意の値を持たせる

      mpm_item_list.forEach((mpm_item, mpm_idx) => {
        common_media_count_up++;
        let src = mpm_item['src'];
        let data_mpm_id = Number(mpm_item['mpm_id']);

        let fileExtension = src.split('.').pop().toLowerCase();

        // ¥ 画像か動画かによって保存先を変更する
        if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
          previewArea.append(`
        <div class="mpm_media_wrapper relative cursor-move inline-block" data-id=${common_media_count_up} data-mpm_id=${data_mpm_id} >
          <video class="mpm_preview_own_media pointer-events-none w-100px h-100px mr-1" data-id=${common_media_count_up} controls src="${src}"></video>
          <div class="mpm_delete_preview_icon absolute z-10 top-[-10px] right-[-2px] w-5 h-5 cursor-pointer text-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>`);
        } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
          previewArea.append(`
        <div class="mpm_media_wrapper relative cursor-move inline-block" data-id=${common_media_count_up} data-mpm_id=${data_mpm_id} >
          <img class="mpm_preview_own_media pointer-events-none w-100px h-100px mr-1" data-id=${common_media_count_up} controls src="${src}" />
          <div class="mpm_delete_preview_icon absolute z-10 top-[-10px] right-[-2px] w-5 h-5 cursor-pointer text-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>`);
        }

        // ¥ 編集時
        let tmp_obj = {};
        tmp_obj[common_media_count_up] = data_mpm_id;
        mpm_files.push(tmp_obj);
      });

      existing_media_html_elements = $('.preview_shown_media_area_for_edit').children();

      $('#mpm_edit_instagram_url').val(mpm_item_instagram_url);
      $('#mpm_edit_caption').val(mpm_item_caption);
      $('#mpm_edit_username').val(mpm_username);
      $('.mpm_platta_ig_edit_modal_container').fadeIn(100);

      let media_url_count_up = -1;

      // ¥ 画像urlをプレビューエリアに表示させる処理 20230615
      $('.mpm_edit_media_url__add_btn')
        .off('click')
        .on('click', function () {
          let mpm_media_url_list = get_url_list('#mpm_edit_media_url');

          // ¥ 20230817
          if (mpm_media_url_list === null) return;

          $('#mpm_edit_media_url').val('');

          const $preview_shown_media_area_for_edit = $('.preview_shown_media_area_for_edit');
          insert_media_to_preview_area($preview_shown_media_area_for_edit, mpm_media_url_list, media_url_count_up);
        });
    });

  // ¥ textareaに入力された画像urlを配列で取得する
  const get_url_list = function (element) {
    // 画像url一覧取得
    let mpm_media_url_jq_list = $(element).val();

    let mpm_media_url_list;
    if (mpm_media_url_jq_list) {
      let mpm_media_url_str = $(element).val();
      // ¥ 余分な空白等含む可能性あり
      mpm_media_url_list = mpm_media_url_str.split('\n');

      // ¥ 要素についているかもしれない前後の空白除去及び 'https://~ ' や "https://~ "などの ' や "を削除
      mpm_media_url_list = $.map(mpm_media_url_list, function (url, idx) {
        return url.replace(/'/g, '').replace(/"/g, '').replace(/,/g, '').trim();
      });
      return mpm_media_url_list;
    } else {
      alert('追加したい投稿のURLを少なくとも１つ入力してください。');
      return null;
    }
  };

  // my_post_media_ordersテーブルのレコードのidをarrayで取得する
  function get_delete_subject_my_post_media_order_ids(clickedElement) {
    // Find the closest parent tr element
    let closestTr = clickedElement.closest('tr');

    // Find all img elements within this tr and extract their data-mpm_id values
    let my_post_media_order_ids = closestTr
      .find('img, video')
      .map(function () {
        return $(this).data('mpm_id'); // Corrected this line
      })
      .get();

    // Now my_post_media_order_ids contains all the data-mpm_id values
    // 例: (4) [1994, 1995, 1996, 1997]
    return my_post_media_order_ids; // Ensure to return the values
  }

  $(function () {
    // $('.mpm_item_list_table').on('click', '#mpm_item_delete', function () {
    $('.mpm_item_list_table')
      .off('click')
      .on('click', '.mpm_item_delete', function () {
        let mpm_sns_post_id = $(this).data('id');
        let mpm_post_type = $(this).data('post_type');
        let clickedElement = $(this);
        console.log('clickedElement :>> ', clickedElement);
        let my_post_media_order_ids = get_delete_subject_my_post_media_order_ids(clickedElement);
        console.log('my_post_media_order_ids :>> ', my_post_media_order_ids);

        if (confirm('この投稿を削除しますか？')) {
          $.ajax({
            url: '/delete_manual_my_post',
            type: 'POST',
            data: {
              mpm_sns_post_id: mpm_sns_post_id,
              mpm_post_type: mpm_post_type,
              delete_flag: 0,
              my_post_media_order_ids: my_post_media_order_ids,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              alert('投稿を削除しました。');
              clickedElement.closest('tr').remove();
              location.reload();
              // 連携の確認をするかもしれないため一応残しておく
            } else if (data.ret == '1') {
              if (!confirm('UGC投稿と連携されています。削除する場合は、連携も解除されます。本当に削除しますか？')) {
                return;
              } else {
                $.ajax({
                  url: '/delete_manual_my_post',
                  type: 'POST',
                  data: {
                    product_id: product_id,
                    product_code: product_code,
                    delete_flag: 1,
                  },
                  dataType: 'json',
                })
                  .done(function (data) {
                    if (data.ret == '0') {
                      alert('商品を削除しました。投稿との連携も解除しました。');
                      location.reload();
                    }
                  })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                    alert('削除に失敗しました。時間を空けてから再度お試しください');
                    console.log(`errorThrown... ${errorThrown}`);
                    console.log(`jqXHR... ${jqXHR}`);
                  });
              }
            }
          });
        }
      });
  }); // end $('.mpm_ugc_set_btn') click
});
